import 'babel-polyfill';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
//import registerServiceWorker from './registerServiceWorker';

import './css/enhance.css';
import './css/main.css';
import './css/control.css';
import './css/study.css';
import './css/add.css';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js